import { GraphqlQueryResponse } from "@Common/api/types/GraphqlQueryResponse";
import { IFinanceDeal } from "@DataPages/types/financeDeals/model";
import { apiInstance, gql } from "@/services/httpAdapter.ts";
import { errorLogger } from "@Common/helpers/logger.ts";
import { Nullish } from "@Common/interfaces/types.ts";

export async function getFinanceDeal(locationId: string, commissionCycleId: string, payPeriodId: string): Promise<Nullish<IFinanceDeal[]>> {
	const query = gql`
		query getFinanceDeal($locationId: String!, $commissionCycleId: String!, $payPeriodId: String!) {
			getFinanceDeal(locationId: $locationId, commissionCycleId: $commissionCycleId, payPeriodId: $payPeriodId) {
				_id
				locationId
				commissionCycleId
				payPeriodId
				age
				date
				stockNumber
				customerNumber
				customerName
				dealNumber
				vinNumber
				lender
				amountFinanced
				financeEmployeeId
				financeEmployeeName
				salesOneEmployeeId
				salesOneEmployeeName
				salesTwoEmployeeId
				salesTwoEmployeeName
				tradeACV
				tradeNet
				closeDate
				activeStatusDV
				dealOriginalDate
				dealStartDate
				dealStatus
				dealType
				financeReserve
				offsetStatusDate
				salesManager
				statusCodeDV
				statusDate
				vstCode
			}
		}
	`;

	const variables = {
		locationId,
		commissionCycleId,
		payPeriodId,
	};

	try {
		const response: GraphqlQueryResponse<"getFinanceDeal", IFinanceDeal[]> = await apiInstance.post("/graphql", { query, variables });
		return response.data.data?.getFinanceDeal ?? null;
	} catch (err) {
		errorLogger(err as Error, { function: "getFinanceDeal", message: "Failed to get finance deal", variables });
		return null;
	}
}
